export class ConsultationUrl {
    public static get GET_CONSULTATION_INVOICES(): string { return '/api/Consultation/{id}/invoices'; }
    public static get GET_CONSULTATION_ATTACHMENT_SHARED(): string { return '/api/Consultation/{id}/attachmentShared'; }
    public static get GET_CONSULTATION_VACCINE_SCHEDULE_LASTEST() { return '/api/Patient/VaccinationSchedulesLastest'; }
    public static get GET_PATIENT_MYTMB() { return '/api/Consultation/getMyTMBPatient'; }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/consultation.url.ts